import {APIService} from '@/services/api.service';
import {Activity} from '@mobi-components/global-solution';

export async function updateBookingStatus(
  userId: string,
  sessionId: string,
  activityId: string,
  status: boolean,
): Promise<Activity[]> {
  try {
    const {activities} = await APIService.post<{activities: Activity[]}>(
      `booking-status`,
      {},
      {
        params: {
          user_id: userId,
          session_id: sessionId,
          activity_id: activityId,
          booking_status: status,
        },
      },
    );
    return activities;
  } catch (e) {
    return [];
  }
}
